// Module
var code = `<ent-horde
  ng-required="\$ctrl.ngRequired"
  ng-model="\$ctrl.values"
  ng-change="\$ctrl.updateModel()"
  tree-data="\$ctrl.treeData"
  node-label="\$ctrl.nodeLabel"
  label-renderer="\$ctrl.renderLabel"
>
</ent-horde>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/filters/tree-filter.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;